/* IntiWell : page Trio. Une ligne par pièce (couleur + taille) ; le panier reçoit les variantes « 1 pièce » de chaque produit, jamais la variante Trio. */
(function(){
  function init(root){
    if (root.dataset.iwReady) return; root.dataset.iwReady = '1';
    var q = function(s){ return root.querySelector(s); }, qa = function(s){ return Array.prototype.slice.call(root.querySelectorAll(s)); };
    var el = function(t, c, txt){ var e = document.createElement(t); if (c) e.className = c; if (txt) e.textContent = txt; return e; };
    var data; try { data = JSON.parse(q('[data-iw-trio-data]').textContent); } catch (e) { return; }
    var form = q('[data-iw-trio-form]'), rows = q('[data-iw-rows]'), alertEl = q('[data-iw-alert]'), toast = q('[data-iw-toast]');
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var shortSize = function(s){ return String(s || '').split(' (')[0]; };
    var variant = data.variants.filter(function(v){ return String(v.id) === q('[data-iw-variant]').value; })[0] || data.variants[0];
    var pieces = [];

    function showToast(msg){ if (!toast) return; toast.textContent = msg; toast.classList.add('is-on'); clearTimeout(showToast.t); showToast.t = setTimeout(function(){ toast.classList.remove('is-on'); }, 4200); }
    function isOut(it, c, s){ return !!s && it.out.indexOf(c + '|' + s) > -1; }
    function firstColor(it){ return it.colors.length ? it.colors[0].n : ''; }
    function name(pc, i){ var it = data.items[pc.k], same = pieces.filter(function(x){ return x.k === pc.k; }); return same.length > 1 ? it.label + ' ' + (same.indexOf(pc) + 1) : it.label; }

    /* ---------- lignes de composition ---------- */
    function build(){
      var mult = (variant && variant.mult) || 1, next = [];
      data.items.forEach(function(it, k){
        var old = pieces.filter(function(x){ return x.k === k; });
        for (var j = 0; j < mult; j++) next.push(old[j] || { k: k, c: (old[0] && old[0].c) || firstColor(it), s: (old[0] && old[0].s) || (it.sizes.length === 1 ? it.sizes[0] : '') });
      });
      pieces = next; rows.innerHTML = '';
      var cnt = q('[data-iw-count]'); if (cnt) cnt.textContent = '· ' + pieces.length + ' pièces';
      pieces.forEach(function(pc, i){
        var it = data.items[pc.k], li = el('li', 'iw-mix__row'); li.dataset.i = i;
        var th = el('span', 'iw-mix__thumb'), im = el('img'); im.alt = ''; im.width = 52; im.height = 52; im.decoding = 'async'; th.appendChild(im);
        if (tpick) { var zb = el('button', 'iw-mix__zoom'); zb.type = 'button'; zb.setAttribute('aria-label', 'Voir en grand : ' + name(pc, i)); th.appendChild(zb); }
        var lab = el('span', 'iw-mix__n', name(pc, i)); lab.appendChild(el('span'));
        var guide = el('a', '', 'Guide des tailles'); guide.href = it.url + '#iw-guide'; guide.target = '_blank'; guide.rel = 'noopener'; lab.appendChild(guide);
        var grp = el('div', 'iw-mix__colors'); grp.setAttribute('role', 'radiogroup'); grp.setAttribute('aria-label', 'Couleur : ' + name(pc, i));
        it.colors.forEach(function(cn){ var b = el('button', 'iw-mix__sw'); b.type = 'button'; b.dataset.name = cn.n; b.style.setProperty('--c', cn.hex); b.setAttribute('role', 'radio'); b.setAttribute('aria-label', cn.n); grp.appendChild(b); });
        var right = el('div'); right.appendChild(lab); right.appendChild(grp);
        li.appendChild(th); li.appendChild(right);
        var sz = el('div', 'iw-mix__sizes'); sz.setAttribute('role', 'group'); sz.setAttribute('aria-label', 'Taille : ' + name(pc, i));
        it.sizes.forEach(function(sv){ var b = el('button', 'iw-size', shortSize(sv)); b.type = 'button'; b.dataset.size = sv; b.setAttribute('aria-label', sv); sz.appendChild(b); });
        if (it.sizes.length < 2) sz.hidden = true;
        li.appendChild(sz);
        rows.appendChild(li); paint(li);
      });
      summary(); syncTpick();
    }
    function paint(li){
      var pc = pieces[+li.dataset.i], it = data.items[pc.k], info = it.colors.filter(function(x){ return x.n === pc.c; })[0] || {};
      var th = li.querySelector('.iw-mix__thumb'), im = th.querySelector('img');
      th.style.setProperty('--c', info.hex || '');
      if (info.thumb) { im.src = info.thumb; im.hidden = false; } else { im.removeAttribute('src'); im.hidden = true; }
      li.querySelector('.iw-mix__n span').textContent = ' · ' + pc.c + (pc.s ? ' · ' + shortSize(pc.s) : '');
      li.querySelectorAll('.iw-mix__sw').forEach(function(b){
        var on = b.dataset.name === pc.c, out = !on && isOut(it, b.dataset.name, pc.s);
        b.setAttribute('aria-checked', on ? 'true' : 'false'); b.tabIndex = on ? 0 : -1;
        b.classList.toggle('is-out', out); b.setAttribute('aria-disabled', out ? 'true' : 'false');
        b.setAttribute('aria-label', b.dataset.name + (out ? ', épuisée en ' + shortSize(pc.s) : ''));
      });
      li.querySelectorAll('.iw-size').forEach(function(b){
        var out = isOut(it, pc.c, b.dataset.size);
        b.disabled = out; b.setAttribute('aria-pressed', b.dataset.size === pc.s ? 'true' : 'false');
        b.setAttribute('aria-label', b.dataset.size + (out ? ', épuisée en ' + pc.c : ''));
      });
      li.classList.toggle('is-alert', li.classList.contains('is-alert') && !pc.s);
    }
    function summary(){
      var sum = q('[data-iw-sum]'); if (!sum) return;
      var done = pieces.filter(function(pc){ return pc.s; }).length;
      sum.textContent = done === pieces.length ? 'Votre composition : ' + pieces.map(function(pc, i){ return name(pc, i) + ' ' + pc.c + ' ' + shortSize(pc.s); }).join(' · ') + '.' : (pieces.length - done) + ' taille' + (pieces.length - done > 1 ? 's' : '') + ' à choisir.';
      if (done === pieces.length && alertEl) alertEl.hidden = true;
    }
    rows.addEventListener('click', function(e){
      var li = e.target.closest('.iw-mix__row'); if (!li) return;
      var pc = pieces[+li.dataset.i], it = data.items[pc.k], b;
      if ((b = e.target.closest('.iw-mix__sw'))) {
        if (b.getAttribute('aria-disabled') === 'true') { showToast(b.dataset.name + ' : épuisé en taille ' + shortSize(pc.s) + ' pour le moment.'); return; }
        pc.c = b.dataset.name; if (isOut(it, pc.c, pc.s)) pc.s = '';
        active = pc.k; touched = true;
        if (want) tshow(pc.k, pc.c, name(pc, +li.dataset.i) + ' · ' + pc.c);   /* l'aperçu ne suit que s'il est déjà ouvert */
      } else if ((b = e.target.closest('.iw-size'))) {
        if (b.disabled) return;
        pc.s = b.dataset.size; li.classList.remove('is-alert');
      } else if ((b = e.target.closest('.iw-mix__zoom'))) { tZoom(+li.dataset.i); return; }
      else return;
      paint(li); summary(); syncTpick();
    });
    rows.addEventListener('keydown', function(e){
      var b = e.target.closest('.iw-mix__sw'); if (!b || ['ArrowRight', 'ArrowLeft', 'ArrowDown', 'ArrowUp'].indexOf(e.key) < 0) return;
      e.preventDefault();
      var all = Array.prototype.slice.call(b.parentNode.children).filter(function(x){ return x === b || x.getAttribute('aria-disabled') !== 'true'; });
      var n = all[(all.indexOf(b) + (e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : all.length - 1)) % all.length];
      if (n) { n.click(); n.focus(); }
    });

    /* ---------- format : Trio ou Grand Trio ---------- */
    function setVariant(v){
      variant = v; q('[data-iw-variant]').value = v.id;
      var price = q('[data-iw-price]'), was = q('[data-iw-was]'), tot = q('[data-iw-total]'), note = q('[data-iw-was-note]');
      if (price) price.textContent = v.price + ' €';
      if (was) was.textContent = v.was ? v.was + ' €' : '';
      if (note) note.hidden = !v.was;
      var wasLine = q('[data-iw-was-line]'), wasN = q('[data-iw-was-n]');
      if (wasLine) wasLine.hidden = !v.was;
      if (wasN) wasN.textContent = String(3 * (v.mult || 1));
      if (tot) tot.textContent = v.price + ' €';
      build();   /* le bouton ne dépend plus de la variante Trio (étiquette de prix), seulement des pièces choisies */
    }
    qa('input[name="iw-format"]').forEach(function(r){ r.addEventListener('change', function(){ var v = data.variants.filter(function(x){ return String(x.id) === r.value; })[0]; if (v) setVariant(v); }); });

    /* ---------- envoi : variantes « 1 pièce » par /cart/add.js, pièces identiques regroupées, sans propriété ; jamais la variante Trio ---------- */
    function idOf(pc){ return (data.items[pc.k].ids || {})[pc.c + '|' + pc.s]; }
    form.addEventListener('submit', function(e){
      e.preventDefault();
      var missing = [];
      qa('.iw-mix__row').forEach(function(li){ var pc = pieces[+li.dataset.i]; if (!pc.s) { missing.push(li); li.classList.add('is-alert'); } });
      var soldOut = pieces.filter(function(pc){ return isOut(data.items[pc.k], pc.c, pc.s) || (pc.s && !idOf(pc)); });
      if (missing.length || soldOut.length) {
        e.preventDefault();
        if (alertEl) { alertEl.hidden = false; alertEl.textContent = missing.length ? 'Choisissez la taille de chaque pièce pour continuer.' : 'Une pièce est épuisée dans cette couleur et cette taille : changez la couleur ou la taille.'; }
        var first = missing[0]; if (first) first.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
        return;
      }
      var agg = {}, items = [];
      pieces.forEach(function(pc){ var id = idOf(pc); agg[id] = (agg[id] || 0) + 1; });
      Object.keys(agg).forEach(function(id){ items.push({ id: +id, quantity: agg[id] }); });
      var cta = q('[data-iw-cta]'), fail = 'L’ajout au panier n’a pas abouti. Réessayez dans un instant.';
      if (cta) { if (cta.disabled) return; cta.disabled = true; }
      fetch(form.dataset.cartAdd, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function(r){
          if (r.ok) { window.location.href = form.dataset.cartUrl; return; }
          /* 422 (pièce épuisée, stock insuffisant) : Shopify a pu ajouter une partie des pièces. Message de Shopify, bouton laissé inactif,
             puis page panier : pas de second envoi possible depuis cette page. Un seul appel items[] pour tout le Trio. */
          return r.json().then(function(d){ return d; }, function(){ return null; }).then(function(d){
            if (r.status !== 422) throw new Error(r.status);
            showToast((d && typeof d.description === 'string' ? d.description : 'L’ajout au panier n’a pas abouti.') + ' Vérifiez votre panier.');
            setTimeout(function(){ window.location.href = form.dataset.cartUrl; }, 3000);
          });
        })
        .catch(function(){ if (cta) cta.disabled = false; showToast(fail); });
    });
    window.addEventListener('pageshow', function(e){ if (e.persisted) { var cta = q('[data-iw-cta]'); if (cta) cta.disabled = false; } });   /* retour arrière depuis le panier (page restaurée) : bouton actif, les pièces sont contrôlées à l'envoi */

    /* ---------- galerie : miniatures, survol, points ---------- */
    var slides = q('[data-iw-slides]'), thumbs = qa('.iw-gallery__thumb'), dots = null;
    if (slides && slides.children.length > 1) {
      dots = el('div', 'iw-gallery__dots'); dots.setAttribute('aria-hidden', 'true');
      for (var i = 0; i < slides.children.length; i++) dots.appendChild(el('span'));
      slides.insertAdjacentElement('afterend', dots);
    }
    function sync(){
      if (!slides) return;
      var k0 = Math.round(slides.scrollLeft / Math.max(1, slides.clientWidth));
      thumbs.forEach(function(t, k){ t.setAttribute('aria-current', k === k0 ? 'true' : 'false'); });
      if (dots) Array.prototype.forEach.call(dots.children, function(d, k){ d.classList.toggle('is-on', k === k0); });
    }
    var hoverThumbs = window.matchMedia && window.matchMedia('(hover: hover) and (min-width: 990px)');
    thumbs.forEach(function(t){
      var go = function(smooth){ slides.scrollTo({ left: slides.clientWidth * parseInt(t.dataset.index, 10), behavior: smooth && !reduce ? 'smooth' : 'auto' }); };
      t.addEventListener('click', function(){ thide(); go(true); });
      t.addEventListener('mouseenter', function(){ if (hoverThumbs && hoverThumbs.matches) go(false); });
    });
    if (slides) { slides.addEventListener('scroll', sync, { passive: true }); sync(); }
    /* ---------- couleur sous la photo (téléphone et tablette, 23/10/2026) ---------- */
    var small = window.matchMedia ? window.matchMedia('(max-width: 989px)') : { matches: false };
    var tpick = q('[data-iw-tpick]'), tpeek = q('[data-iw-tpeek]'), tpImg = tpeek ? tpeek.querySelector('img') : null, tpCap = q('[data-iw-tpeek-cap]'), tpX = q('[data-iw-tpeek-x]');
    var active = 0, touched = false, want = '', tLeft = 0;
    function itemPcs(k){ return pieces.filter(function(pc){ return pc.k === k; }); }
    function cInfo(k, c){ return (data.items[k] ? data.items[k].colors : []).filter(function(x){ return x.n === c; })[0] || {}; }
    function usedC(list){ var o = []; list.forEach(function(pc){ if (o.indexOf(pc.c) < 0) o.push(pc.c); }); return o; }
    function stickTop(){ var v = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--iw-stick')); return isNaN(v) ? 64 : v - 16; }
    function photoShown(){ if (!slides) return 1; var r = slides.getBoundingClientRect(), t = Math.max(r.top, stickTop()), b = Math.min(r.bottom, window.innerHeight); return Math.max(0, b - t) / Math.max(1, r.height); }
    function revealPhoto(){
      if (!small.matches || !slides || !tpick || photoShown() >= 0.5) return;
      var g = slides.getBoundingClientRect(), row = tpick.querySelector('.iw-tpick__sws:not([hidden])') || tpick, r = row.getBoundingClientRect();
      var d = Math.max(g.top - stickTop(), r.bottom + 12 - window.innerHeight);
      if (Math.abs(d) > 4) window.scrollTo({ top: Math.max(0, window.pageYOffset + d), behavior: reduce ? 'auto' : 'smooth' });
    }
    function tStatus(k){
      var it = data.items[k], list = itemPcs(k), u = usedC(list); if (!it || !u.length) return '';
      var lab = list.length > 1 ? it.label + ', ' + list.length + ' pièces' : it.label;
      var val = u.length === 1 ? u[0] : u.map(function(c){ return list.filter(function(pc){ return pc.c === c; }).length + ' ' + c; }).join(', ');
      return lab + ' : ' + val + (u.length === 1 && !cInfo(k, u[0]).src ? ', photos en préparation' : '');
    }
    function buildTpick(){
      var cards = el('div', 'iw-tpick__cards'); cards.setAttribute('role', 'group'); cards.setAttribute('aria-label', 'Pièce à voir en photo'); tpick.appendChild(cards);
      data.items.forEach(function(it, k){
        var t = el('button', 'iw-tpick__card'), ph = el('span', 'iw-tpick__ph'), im = el('img');
        t.type = 'button'; t.dataset.k = k; im.alt = ''; im.width = 28; im.height = 28; im.decoding = 'async';
        ph.appendChild(im); t.appendChild(ph); t.appendChild(el('span', 'iw-tpick__t', it.label)); cards.appendChild(t);
      });
      data.items.forEach(function(it, k){
        var row = el('div', 'iw-tpick__sws'); row.dataset.k = k; row.setAttribute('role', 'radiogroup'); row.setAttribute('aria-label', 'Couleur : ' + it.label);
        it.colors.forEach(function(cn){ var b = el('button', 'iw-gpick__sw'); b.type = 'button'; b.dataset.name = cn.n; b.style.setProperty('--c', cn.hex); b.setAttribute('role', 'radio'); row.appendChild(b); });
        tpick.appendChild(row);
      });
      var note = el('p', 'iw-tpick__note'); note.setAttribute('aria-live', 'polite'); tpick.appendChild(note);
    }
    function syncTpick(){
      if (!tpick || !tpick.firstChild) return;
      if (!data.items[active]) active = 0;
      tpick.querySelectorAll('.iw-tpick__card').forEach(function(t){
        var k = +t.dataset.k, list = itemPcs(k), inf = list[0] ? cInfo(k, list[0].c) : {}, im = t.querySelector('img');
        t.querySelector('.iw-tpick__ph').style.setProperty('--c', inf.hex || '');
        if (inf.thumb) { if (im.getAttribute('src') !== inf.thumb) im.src = inf.thumb; im.hidden = false; } else { im.removeAttribute('src'); im.hidden = true; }
        t.setAttribute('aria-pressed', k === active ? 'true' : 'false');
        t.setAttribute('aria-label', data.items[k].label + ', ' + usedC(list).join(' et '));
      });
      tpick.querySelectorAll('.iw-tpick__sws').forEach(function(row){
        var k = +row.dataset.k, it = data.items[k], list = itemPcs(k), u = usedC(list), cur = u.length === 1 ? u[0] : '', sws = Array.prototype.slice.call(row.children), tab = null;
        row.hidden = k !== active;
        sws.forEach(function(b){
          var c = b.dataset.name, on = c === cur, bad = on ? null : list.filter(function(pc){ return isOut(it, c, pc.s); })[0];
          b.setAttribute('aria-checked', on ? 'true' : 'false'); b.classList.toggle('is-out', !!bad); b.setAttribute('aria-disabled', bad ? 'true' : 'false');
          b.setAttribute('aria-label', c + (bad ? ', épuisée en ' + shortSize(bad.s) : '')); if (on) tab = b;
        });
        tab = tab || sws.filter(function(b){ return b.getAttribute('aria-disabled') !== 'true'; })[0] || sws[0];
        sws.forEach(function(b){ b.tabIndex = b === tab ? 0 : -1; });
      });
      var note = tpick.querySelector('.iw-tpick__note'), txt = touched ? tStatus(active) : 'Touchez une couleur pour la voir portée.';
      if (note.textContent !== txt) note.textContent = txt;
    }
    function warm(k, c){ if (!small.matches) return; var inf = cInfo(k, c); if (!inf.src) return; var im = new Image(); im.sizes = '(min-width: 990px) 55vw, 100vw'; if (inf.srcset) im.srcset = inf.srcset; im.src = inf.src; }
    function tshow(k, c, cap){
      if (!tpeek || !tpImg || !small.matches) return;
      var inf = cInfo(k, c), key = k + '|' + c;
      if (!inf.src) { thide(); return; }
      want = key; tLeft = slides ? slides.scrollLeft : 0;
      if (tpImg.getAttribute('src') !== inf.src) { tpImg.sizes = '(min-width: 990px) 55vw, 100vw'; tpImg.srcset = inf.srcset || ''; tpImg.src = inf.src; }
      var on = function(){ if (want !== key) return; tpCap.textContent = cap; tpeek.classList.add('is-on'); if (tpX) tpX.hidden = false; };
      tpImg.onload = on; if (tpImg.complete && tpImg.naturalWidth) on();   /* jamais de cadre vide devant la photo (règle de J 179-181) ; le dernier appel garde la main sur l'événement load */
    }
    function thide(){ want = ''; if (tpeek) tpeek.classList.remove('is-on'); if (tpX) tpX.hidden = true; }
    function tApply(c){
      var k = active, it = data.items[k], list = itemPcs(k), bad = list.filter(function(pc){ return isOut(it, c, pc.s); })[0];
      if (bad) { showToast(c + ' : épuisé en taille ' + shortSize(bad.s) + ' pour le moment.'); return; }
      list.forEach(function(pc){ pc.c = c; });
      qa('.iw-mix__row').forEach(function(li){ if (pieces[+li.dataset.i].k === k) paint(li); });
      touched = true; summary(); syncTpick();
      tshow(k, c, it.label + ' · ' + c); revealPhoto();
    }
    function tZoom(i){
      var pc = pieces[i]; if (!pc || !small.matches) return;
      active = pc.k; touched = true; syncTpick();
      tshow(pc.k, pc.c, name(pc, i) + ' · ' + pc.c);
      var g = q('.iw-gallery'); if (g) g.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    }
    if (tpick) {
      buildTpick();
      tpick.addEventListener('pointerdown', function(e){   /* commencer à charger la seule photo qui va s'afficher */
        var b = e.target.closest('.iw-gpick__sw'), t = e.target.closest('.iw-tpick__card');
        if (b) warm(active, b.dataset.name); else if (t) { var p0 = itemPcs(+t.dataset.k)[0]; if (p0) warm(p0.k, p0.c); }
      }, { passive: true });
      tpick.addEventListener('click', function(e){
        var t = e.target.closest('.iw-tpick__card'), b = e.target.closest('.iw-gpick__sw');
        if (t) { active = +t.dataset.k; touched = true; syncTpick(); var p0 = itemPcs(active)[0]; if (p0) tshow(active, p0.c, data.items[active].label + ' · ' + p0.c); revealPhoto(); return; }
        if (!b) return;
        if (b.getAttribute('aria-checked') === 'true') { touched = true; syncTpick(); tshow(active, b.dataset.name, data.items[active].label + ' · ' + b.dataset.name); revealPhoto(); return; }
        tApply(b.dataset.name);
      });
      tpick.addEventListener('keydown', function(e){   /* comme TJ 82-88 */
        var b = e.target.closest('.iw-gpick__sw'); if (!b || ['ArrowRight', 'ArrowLeft', 'ArrowDown', 'ArrowUp'].indexOf(e.key) < 0) return;
        e.preventDefault();
        var all = Array.prototype.slice.call(b.parentNode.children).filter(function(x){ return x === b || x.getAttribute('aria-disabled') !== 'true'; });
        var n = all[(all.indexOf(b) + (e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : all.length - 1)) % all.length];
        if (n) { n.click(); n.focus(); }
      });
      if (tpX) tpX.addEventListener('click', thide);
      if (slides) slides.addEventListener('scroll', function(){ if (want && Math.abs(slides.scrollLeft - tLeft) > 8) thide(); }, { passive: true });
      var offSmall = function(){ if (!small.matches) thide(); };
      if (small.addEventListener) small.addEventListener('change', offSmall); else if (small.addListener) small.addListener(offSmall);
    }

    /* ---------- livraison estimée (jours ouvrés) ---------- */
    var eta = q('[data-iw-eta]');
    if (eta) {
      var addBiz = function(n){ var d = new Date(); while (n > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) n--; } return d; };
      var df = new Intl.DateTimeFormat('fr-FR', { weekday: 'long', day: 'numeric', month: 'long' });
      eta.textContent = eta.dataset.text.replace('{min}', df.format(addBiz(parseInt(eta.dataset.min, 10) || 0))).replace('{max}', df.format(addBiz(parseInt(eta.dataset.max, 10) || 0)));
    }

    if (variant) setVariant(variant); else build();
  }
  function boot(){ Array.prototype.forEach.call(document.querySelectorAll('[data-iw-trio]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
